<template lang="pug">
  
  .profile
    v-container(grid-list-lg)
      v-layout(row wrap)
        v-flex(xs12): .headline {{ $t("profile.title") }}
        v-flex(xs6)
          v-card
            v-card-title.pb-0: div
              .title {{ $t("profile.data") }}
            //- v-subheader Tu możesz zmienić ustawienia związane z powiadomieniami
            v-card-text.py-0
              v-text-field(
                v-model="name"
                :label="$t('profile.name')"
                :rules="rules.name"
                :error-messages="errors.name"
              )
              v-text-field(
                v-model="position"
                :label="$t('profile.position')"
                :error-messages="errors.position"
              )
              //- upload-btn(accept="image/*" icon @file-update="fileUpdate")
                template(slot="icon")
                  v-icon mdi-upload
            v-card-actions.justify-end
              v-btn(text color="primary" @click="updateProfile") {{ $t("profile.save") }}

        v-flex(xs6)
          v-card
            v-card-title.pb-0: div
              .title {{ $t("profile.notifications") }}
            //- v-subheader Tu możesz zmienić ustawienia związane z powiadomieniami
            v-card-text.py-0
              v-alert.mt-3(:value="!!webpush_error" type="error" outlined) {{ webpush_error }}
              v-checkbox(
                :label="$t('profile.webpush')"
                v-model="webpush"
                :disabled="!webpush_enabled"
              )
        v-flex(xs6)
          v-card
            v-card-title.pb-0: div
              .title {{ $t("profile.appearance") }}
            //- v-subheader Tu możesz zmienić ustawienia związane z powiadomieniami
            v-card-text.py-0
              v-checkbox(
                :label="$t('profile.dark_mode')"
                v-model="dark"
              )

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UploadBtn from '../components/UploadButton'

export default {

  components: {
    UploadBtn
  },

  data() {
    return {
      name: '',
      position: '',
      rules: {
        name: [
          v => !!v || this.$t('validation.required', { field: this.$t('profile.name') }),
        ],
      },
      errors: {},
    }
  },

  computed: {
    ...mapGetters('webpush', {
      webpush_enabled: 'enabled',
      webpush_error: 'error',
    }),
    ...mapGetters('auth', [
      'settings',
      'user',
    ]),
    dark: {
      get() {
        return this.settings.theme == 'dark'
      },
      set(dark) {
        this.setSettings({ theme: dark ? 'dark' : 'light' })
      }
    },
    webpush: {
      get() {
        return this.$store.getters['webpush/subscribed']
      },
      set(webpush) {
        if(webpush) this.webpushSubscribe()
        else        this.webpushUnsubscribe()
      }
    },
  },

  watch: {
    name() {
      this.errors.name = undefined
    },
    user(user) {
      this.name = user.name
      this.position = user.position
    },
  },

  mounted() {
    this.name = this.user && this.user.name || ''
    this.position = this.user && this.user.position || ''
  },

  methods: {
    ...mapActions('auth', [
      // 'updateProfile',
      'setSettings',
    ]),
    ...mapActions('webpush', {
      webpushSubscribe: 'subscribe',
      webpushUnsubscribe: 'unsubscribe',
    }),
    fileUpdate (file) {
      // handle file here. File will be an object.
      // If multiple prop is true, it will return an object array of files.
      console.log(files);
    },
    updateProfile() {
      const data = {
        name: this.name,
        position: this.position || null
      }
      this.$store.dispatch('auth/updateProfile', data)
        .then(response => this.errors = {})
        .catch(failed => this.errors = failed.errors || {})
    }
  }
}
</script>